import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, LazyImport, type LazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "MeetNow" */ "./lazyIndex"), {
    name: "MeetNow",
});

export const MeetNowSuiteHeaderButton: LazyComponent<unknown, unknown, void> = createLazyComponent(lazyModule, m => m.MeetNowSuiteHeaderButton);

export const lazyIsMeetNowEnabled: LazyImport<typeof lazyIndex.isMeetNowEnabled, typeof lazyModule> = new LazyImport(lazyModule, m => m.isMeetNowEnabled);
